import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css, injectGlobal} from 'styled-components';
import { rgba } from 'polished';
import { Link } from 'react-router-dom'
import moment from 'moment'
import Parser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { LetterLinks, Annotation } from '../../components'
import { CSSTransitionGroup } from 'react-transition-group' 
import VisibilitySensor from 'react-visibility-sensor';
import Fade from 'react-reveal/Fade';

import { fetchLetters, getLetters } from '../Letter/redux';

import { isClient } from '../../utils'
import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding, Title } from '../../styles/global';
import { media, width } from '../../styles/utils';

import PledgeIcon from 'svg-react-loader?name=Icon!../../assets/icons/pledge-icon.svg';
import ArrowRight from 'svg-react-loader?name=Icon!../../assets/icons/arrow-right-black.svg';
import MetaTags from '../../components/MetaTags/MetaTags';

class Letter extends Component {

    state = {
        letterType: null,
        secondaryInfo: {
            template: 'title',
            data: null
        },
        activeAnnotation: null,
        totalSections: 0,
        activeSection: 0,
        mounted: false,
        activeSections: [] // different state method for tablet / mobile 
    }

    componentWillMount = () => {
        const slug = this.props.match.params.slug;

        this.props.fetchLetters()

        if (slug) {
            this.setState({
                letterType: slug,
            })
        }
    }

    componentDidMount = () => {
        this.setState({
            mounted: true
        })
    }    

    componentWillUpdate = (nextProps, nextState) => {
        const { letterType } = nextState;   
        const { letters } = nextProps;

        // Set total sections for counter

        if (this.props.letters != letters) {
            const letter = letters.data[letterType]
            
            this.setState({
                totalSections: letter.length
            })
        }
    }
    
    isAnnotationActive = (index, section) => {
        const { activeAnnotation } = this.state;   

        if (activeAnnotation && activeAnnotation.index == index && activeAnnotation.section == section) {
            return true;
        }

        return false
    }
 
    toggleAnnotation = (active, index, section, node) => {
        const { letterType, activeAnnotation } = this.state;   
        const { letters } = this.props;

        const annotation = letters.data[letterType].sections[section].annotations[index - 1];

        if (active) {
            this.setState({
                activeAnnotation: {
                    section: section,
                    index: index,
                },
                secondaryInfo: {
                    template: annotation.url_or_text,
                    data: annotation,
                    originText: node.children[0].data
                }
            })
        }
    }

    onSectionChange = (visibility, index) => {
        if (visibility) {
            this.setState({
                activeSection: index
            })
        }
    }
    
    transformNode = (node, sectionIndex) => {
        const { activeAnnotation } = this.state;

        if (node.name === 'a') {
            const index = node.attribs['data-annotationindex'];
            
            return (
                <Annotation
                    callback={this.toggleAnnotation}
                    index={parseInt(index)}
                    section={sectionIndex}
                    data={node}
                    active={this.isAnnotationActive(index, sectionIndex)}
                />
            )
        }
        
        if (node.children) {
            node.children.forEach((node) => this.transformNode(node))
        }
    }
    renderSecondaryTitle = () => {
        const { letterType } = this.state;        

        return (
            <SecondaryTitle>
                <Fade>
                    <Title>{letterType == 'client' ? 'Client' : 'Artist'} Letter</Title>
                </Fade>
            </SecondaryTitle>
        )
    }

    renderQuestions = () => {
        const { letterType, mounted, activeSection, activeSections} = this.state;   
        const { letters } = this.props;

        console.log(activeSections)

        if (letters.data && mounted) {
            const sections = letters.data[letterType].sections.map((section, i) => {
                return (
                    <Section
                        active={width.tablet() ? activeSections[i + 1] : activeSection == i + 1}
                    >
                        {section.heading && (
                            <Top>
                                <Marker>{section.title}</Marker>
                                <Heading
                                    active={activeSection == i + 1}
                                    onClick={() => this.updateActiveSection(i + 1)}
                                >
                                    {section.heading}
                                </Heading>
                            </Top>
                        )}

                        {section.content && (
                            <Content
                                dangerouslySetInnerHTML={{__html: section.content}}
                            />
                        )}
                    </Section>
                 )
            })
            
            return (
                <LetterBody>
                    <MetaTags    
                        title={`${letterType == 'client' ? 'Client' : 'Artist'} Letter`}   
                        description={letters.data[letterType].introduction}
                    />
                    
                    <Fade
                        up
                        duration={1000}
                        distance={'50px'}
                    >
                        <Intro
                            dangerouslySetInnerHTML={{__html: letters.data[letterType].introduction}}
                        />

                        {sections}
                    </Fade>
                </LetterBody>
            )   
        } else {
            return (
                <LetterBody>

                </LetterBody>
            )
        }
    }

    renderAnswerContent = () => {
        const { letterType, activeSection } = this.state;   
        const { letters } = this.props;
   
        return (
            <SecondaryInfo
                titleVisible={activeSection === 0}
                letterType={letterType == 'client' ? 'Client' : 'Artist'}
            >
                {activeSection === 0 && this.renderSecondaryTitle()}
                {activeSection > 0 && (
                    <SecondaryText>
                        <Content
                            dangerouslySetInnerHTML={{__html: letters.data[letterType].sections[activeSection-1].content}}
                        />
                    </SecondaryText>
                )}
            </SecondaryInfo>
        )
    }

    updateActiveSection = (index) => {
        const activeSections = [
            ...this.state.activeSections
        ]

        activeSections[index] = true;
        
        this.setState({ 
            activeSections: activeSections,
            activeSection: index 
        })
    }
    
    render() {
        const { mounted } = this.state;
        return (
            <Container>
                {this.renderQuestions()}
                {this.renderAnswerContent()}  
            </Container>
        )
    }
}

const Container = styled.div`
    background: #F7F7F7;
    display: flex;
`;


const panel = css`
    display: flex;
    width: 50vw;
    height: 100vh;
    max-height: 100vh;
    overflow-y: scroll;
`;

// Letter body

const LetterBody = styled.div`
    ${panel}
    background: white;
    padding: 0 64px;
    padding-top: 192px;
	padding-bottom: 96px;
    box-sizing: border-box;
    flex-direction: column;

    ${media.tablet`
        width: 100vw;
    `}

    ${media.phone`
        padding: 0 20px;


        .react-reveal {
            margin-bottom: 64px;
            
            &:first-child {
                margin-top: 64px;
            }

            &:last-child {
                margin-bottom: 128px;
            }
        }
    `}
`

const Intro = styled.div`
    ${body}
    color: #5F5F5F;
    margin-bottom: 60px;

    p { 
        ${body}
    }
`

const Content = styled.div`
    ${body}
    color: #5F5F5F;

    p { 
        ${body}
    }
`

const Section = styled.div`
    margin-bottom: 64px;  
    width: 100%;

    ${Content} {
        display: none;
    }

    ${media.phone`
        margin-bottom: 0px;
    `}

    ${props => {
        if (props.active) return css`
            ${media.tablet`
                ${Content} {
                    padding-top: 32px;
                    display: flex;
                    flex-direction: column;
                }
            `}
        `
    }}
`

const Top = styled.div``

const Marker = styled.div`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: black;
    opacity: 0.33;
    letter-spacing: 2.04px;
    margin-bottom: 14px;
`

const Heading = styled.div`
    font-family: Platform-Medium;
    font-size: 33px;
    color: #4D4D4D;
    letter-spacing: 0;
    line-height: 39px;
    display: inline;

    ${hoverState}
    user-select: none;

    &:hover {
        cursor: pointer;
        opacity: 1;
    }

    ${media.phone`
        margin-bottom: 32px;
    `}

    ${props => {
        if (props.active) return css`
            background: #B8EEB3;
        `
    }}
`

// Secondary Title 

const SecondaryTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    ${Title} {
        color: #4D4D4D;
    }
`;


// Secondary Info 

const SecondaryInfo = styled.div`
    ${panel}
    background: #F9F9F9;
    overflow-y: hidden;
    position: relative;
    transition: all 0.1s ease;

    ${media.tablet`
        display: none;
    `}

    ${props => {
        if (props.titleVisible && props.letterType == 'Artist') return css`
            background: #9A66FE;     

            ${Title} {
                color: white;
                text-shadow: 1px 1px 60px #0000000f;
            }
        `

        if (props.titleVisible) return css`
            background: #DB5537;     

            ${Title} {
                color: white;
                text-shadow: 1px 1px 60px #0000000f;
            }
        `
    }}
`;

const secondaryMeta = css`
    opacity: 0.33;
    font-family: 'Platform-Regular';
    font-size: 13px;
    letter-spacing: 2.04px;

    position: absolute;
`

const Back = styled(Link)`
    ${secondaryMeta}
    left: 26px;
    top: 24px;
    text-transform: uppercase;
    ${hoverState}
`;

const Counter = styled.div`
    ${secondaryMeta}
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
`;


// Secondary Link

const SecondaryLink = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
`;

const LinkTitle = styled.a`
    ${hoverState};
    font-family: TiemposText-Regular;
    font-size: 21px;
    color: #4D4D4D;
    margin-bottom: 18px;

    text-align: center;
    padding: 0 24px;
`;

const LinkCaption = styled.div`
    opacity: 0.5;
    font-family: TiemposText-Regular;
    font-size: 15px;
    color: #4D4D4D;
    margin-bottom: 48px;
    text-align: center;
    padding: 0 24px;
    line-height: 24px;
    max-width: 600px;
`;

const IFRAMESCALE = 0.35;

const FrameContainer = styled.div`
    position: relative;
    width: calc(1440px * ${IFRAMESCALE});
    height: calc(900px * ${IFRAMESCALE});
    margin-bottom: 48px;
    box-shadow: 0 8px 18px 0 rgba(0,0,0,0.05);
    background: white;  

    /* Block pointer events  */

    &:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        /* background: black; */
    }
`;

const LinkFrame = styled.div`
    transform: scale(${IFRAMESCALE});
    transform-origin: 0 0;
    position: relative;

    > iframe {
        appearance: none;
        border: 0;
        width: 1440px;
        height: 900px;
        pointer-events: none;
    }
`;

const LinkDescriptor = styled.a`
    ${hoverState};
    display: flex;
    align-items: center;

    opacity: 0.33;
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: black;
    letter-spacing: 2.04px;
    margin-bottom: 48px;
    cursor: pointer;

    text-align: center;
    padding: 0 24px;
`;

const Arrow = styled(ArrowRight)`
    margin-left: 5px;
    transform: translateY(-1px);
`

const LinkOriginText = styled.div`
    opacity: 0.87;
    font-family: TiemposText-RegularItalic;
    font-size: 14px;
    color: #434343;
    line-height: 27px;
`;

// Secondary Text

const SecondaryText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow-y: scroll;

    ${Heading} {
        font-family: Platform-Medium;
        font-size: 28px;
        color: #4D4D4D;
        line-height: 39px;
        margin-bottom: 32px;
    }

    ${Content} {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        max-width: 640px;
        margin-top: 48px;
        max-height: 100%;

        p {
            font-family: 'Platform-Regular';
            font-size: 15px;
            color: #686868;
            letter-spacing: 0.4px;
            line-height: 26px;
            margin: 0;

            &:not(:last-child) {
                margin-bottom: 1rem;
            }

            &:last-child {
                margin-bottom: 80px;
            }
        }
    }
`;

const PledgeLink = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;

    padding: 0 20px;
    height: 43px;
    flex: 0 1 auto;
    
    font-family: 'Platform-Regular';
    font-size: 12px;
    color: #7ED321;
    letter-spacing: 2.18px;
    text-transform: uppercase;

    border: 1px solid #7ED321;
    border-radius: 4px;

    margin: 100px 0 200px;

    ${hoverState}

    >:first-child {
        margin-right: 20px;
    }
`;

injectGlobal`
    .example-enter {    
        opacity: 0.01;
    }

    .example-enter.example-enter-active {
        opacity: 1;
        transition: opacity 500ms ease-in;
    }

    .example-leave {
        opacity: 1;
    }

    .example-leave.example-leave-active {
        opacity: 0.01;
        transition: opacity 300ms ease-in;
    }

    .react-reveal {
        display: flex;
        justify-content: center;
    }
`


const mapDispatchToProps = dispatch => ({
    fetchLetters() {
        dispatch(fetchLetters())
    }
})

const mapStateToProps = (state, props) => ({
    letters: getLetters(state)
})


export default connect(mapStateToProps, mapDispatchToProps)(Letter);



// WEBPACK FOOTER //
// ./client/modules/Letter/Letter.js